export default class ConditionNodeConst {
    static VAR_COND_IN='variableConditionInput';
  }
